import { SprintWeek } from 'shared/sprint-week';

/**
 * Whether this is the last gated lesson of the student's current sprint week
 * and already open to them — the Friday lesson on a daily drip, and the one
 * students most often finish without marking complete.
 */
export function isLastLessonOfWeek(week: SprintWeek | undefined, lessonId: UUID) {
  const lessons = week?.lessons ?? [];
  const last = lessons[lessons.length - 1];
  return !!last && last.id === lessonId && last.status !== 'upcoming';
}

/**
 * Whether the completion gate already counts this lesson done for the week:
 * marked complete here, or done by the gate's own rule (which also counts a
 * submitted assignment).
 */
export function isDoneForWeek(opts: {
  week: SprintWeek | undefined;
  lessonId: UUID;
  isComplete: boolean;
}) {
  return (
    opts.isComplete || opts.week?.lessons.find((l) => l.id === opts.lessonId)?.status === 'done'
  );
}
